import { render, staticRenderFns } from "./LinkWithTip.vue?vue&type=template&id=2f51889e&scoped=true&"
import script from "./LinkWithTip.vue?vue&type=script&lang=js&"
export * from "./LinkWithTip.vue?vue&type=script&lang=js&"
import style0 from "./LinkWithTip.vue?vue&type=style&index=0&id=2f51889e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f51889e",
  null
  
)

export default component.exports